import { useMutation } from '@tanstack/react-query';

export function useCreateProjectsAnalyticsProjectsReportsReviewStatusReportsExportProcessMutation() {
  return useMutation({
    mutationKey: [
      'createProjectsAnalyticsProjectsReportsReviewStatusReportsExportProcess',
    ],
    mutationFn: async ({ params }) => {
      const response = await axios.post(
        '/projects_analytics/projects_reports/review_status_reports/export_processes',
        { export_process: params },
      );

      return response.data;
    },
  });
}
